if (tippy) {
	tippy.delegate('#primary', {
		target: '.fulcrum-tooltip',
		allowHTML: true,
		maxWidth: 275,
		interactive: true,
		appendTo: () => document.body,
		theme: 'erosion',
		placement: 'top',
		animation: 'scale-subtle',
		content: (ref) => {
			const tip = ref.querySelector('.fulcrum-tooltip-content');
			return tip;
		},
	})
} 